module.exports = {["template-constructor-control-common_lock"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon noarrow" data-alt="Lock" data-alt-pos="left" data-alt-offset="9"></div>\n';
}
return __p;
},}